/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Imran's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Imran Pariyani Portfolio",
    type: "website",
    url: "http://pariyani.com/",
  },
};

//Home Page
const greeting = {
  title: "Imran Pariyani",
  logo_name: "ImranPariyani",
  nickname: "pariyani",
  subTitle:"greeting.subtitle",
  resumeLink:
    "https://drive.google.com/file/d/1FL_wydnPF2SWCdw2goYAgZ1KKBx8TpcD/view?usp=sharing",
  portfolio_repository: "https://github.com/pariyani",
  githubProfile: "https://github.com/pariyani",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/pariyani",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/pariyani/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Xing",
    link: "https://www.xing.com/profile/Imran_Pariyani/",
    fontAwesomeIcon: "fa-xing", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0698A0", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://youtube.com/c/imranpariyani",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:pariyani@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/pariyani",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/pariyani/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/pariyani/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
		{
			title: "skill.backend",
      fileName: "DataScienceImg",
      skills: [
        "skill.backend.info1",
        "skill.backend.info2",
        "skill.backend.info3",
        "skill.backend.info4",
        "skill.backend.info5",
      ],
      softwareSkills: [
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "skill-icons:typescript",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Kafka",
          fontAwesomeClassname: "skill-icons:kafka",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "skill-icons:git",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "skill-icons:docker",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Gradle",
          fontAwesomeClassname: "simple-icons:gradle",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Hibernate",
          fontAwesomeClassname: "simple-icons:hibernate",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Spring",
          fontAwesomeClassname: "simple-icons:spring",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "logos:kubernetes",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "IntelliJ IDEA",
          fontAwesomeClassname: "logos:intellij-idea",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Eclipse",
          fontAwesomeClassname: "devicon:eclipse",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "GrapgQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#E538AC",
          },
        },
        {
          skillName: "Tomcat",
          fontAwesomeClassname: "logos:tomcat",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Apache",
          fontAwesomeClassname: "logos:apache",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "logos:redis",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "RabbitMQ",
          fontAwesomeClassname: "devicon:rabbitmq",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Markdown",
          fontAwesomeClassname: "logos:markdown",
          style: {
            color: "#02569B",
          },
        },
        
        {
          skillName: "npm",
          fontAwesomeClassname: "logos:npm-icon",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Kibana",
          fontAwesomeClassname: "logos:kibana",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "ESLint",
          fontAwesomeClassname: "logos:eslint",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Atom",
          fontAwesomeClassname: "skill-icons:atom",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Logstash",
          fontAwesomeClassname: "logos:logstash",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Apache Camel",
          fontAwesomeClassname: "logos:apache-camel",
          style: {
            color: "#02569B",
          },
        },
        {
					skillName: "XBRL",
					imageSrc: "XBRL.png",
				},
      ]
		},
		{
			title: "skill.frontend",
      fileName: "FullStackImg",
      skills: [
				"skill.frontend.info1",
				"skill.frontend.info2",
				"skill.frontend.info3",
				"skill.frontend.info4",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "devicon:css3-wordmark",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "skill-icons:typescript",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "simple-icons:gatsby",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "ES6",
          imageSrc: "es6.jpg",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "GrapgQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#E538AC",
          },
        },
        {
          skillName: "ExpressJS",
          imageSrc: "expressjs.png",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FD6C35",
          },
        },
        {
          skillName: "GitLab",
          fontAwesomeClassname: "logos:gitlab",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "IntelliJ IDEA",
          fontAwesomeClassname: "logos:intellij-idea",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "ESLint",
          fontAwesomeClassname: "logos:eslint",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Atom",
          fontAwesomeClassname: "skill-icons:atom",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Babel",
          fontAwesomeClassname: "skill-icons:babel",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "WebStorm",
          fontAwesomeClassname: "logos:webstorm",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "SourceTree",
          fontAwesomeClassname: "logos:sourcetree",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Jira",
          fontAwesomeClassname: "logos:jira",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Confluence",
          fontAwesomeClassname: "logos:confluence",
          style: {
            color: "#02569B",
          },
        },
      ],
		},
    {
      title: "skill.cloud",
      fileName: "CloudInfraImg",
      skills: [
      	"skill.cloud.info1",
      	"skill.cloud.info2",
      	"skill.cloud.info3",
      	"skill.cloud.info4",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    {
      title: "skill.uxui",
      fileName: "DesignImg",
      skills: [
        "skill.uxui.info1",
        "skill.uxui.info2",
        "skill.uxui.info3",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Inkscape",
          fontAwesomeClassname: "simple-icons:inkscape",
          style: {
            color: "#000000",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "MIT Academy of Engineering - Pune University",
      subtitle: "Bachelor of Electronics and Telecommunication Engineering",
      logo_path: "mit_logo.png",
      alt_name: "MIT Academy of Engineering",
      duration: "1999 - 2003",
      descriptions: [
        "⚡ Bachelor of Electronics and Telecommunication Engineering from University of Pune"
      ],
      website_link: "https://mitaoe.ac.in/",
    },
    {
      title: "Leuphana Universität Lüneburg",
      subtitle: "M.S. in Software Technology",
      logo_path: "Leuphana_logo.png",
      alt_name: "Leuphana Universität Lüneburg",
      duration: "2004 - 2006",
      descriptions: [
        "⚡ I have taken varity of courses related to Artificial Intelligence which correspond to Explainable AI, Graph Machine Learning, Computer Vision etc.",
      ],
      website_link: "https://www.leuphana.de/",
    },
  ],
};

// Experience Page
const experience = {
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      index:1,
      experiences: [
        {
          title: "Senior Architect",
          company: "Fwsb GmbH",
          company_url: "https://www.fwsb.de/",
          logo_path: "fwsb_logo.png",
          duration: "May 2006 - Present",
          location: "Eschborn, Germany",
          color: "#0879bf",
          projects:[
						{
						name: "Ebilanz Online and DEFTAX (Deferred tax)",
						desc:"FWSB has successfully established there business in the areas of seminars, consulting and the software solutions DefTax® and EBilanz Online. They are meanwhile one of the renowned specialists for national and international accounting standards and financial statement analyses in the German market. The conversion of financial reporting systems from German GAAP to IFRS as well as general optimizations of financial reporting policies is there focus.",
						stack:"Tomcat 7, J2EE, XBRL, JSF, Struts, HIBERNATE, XBRL, JAXB, OOAD, JSP, JDBC, UML, XML, XSLT, MySQL, JQuery, SOAP, WSDL, AJAX, Git, ANT, Payment gateway, Jira, confluence."
						},{
						name: "ESEF-Manager.eu",
						desc:"Mit dem neuen geforderten ESEF-Berichtsformat tritt die Jahresfinanzberichtserstattung in das digitale Zeitalter. Dadurch ändern sich die Erstellungsprozesse für Emittenten, sowie Prüfprozesse für Wirtschaftsprüfer. Um den neuen regulatorischen Anforderungen gerecht zu werden, empfiehlt sich eine technische Lösung. Im ESEF-Manager können Jahresfinanzberichte sowohl im ESEF-Berichtsformat erstellt, als auch geprüft werden. ",
						stack:"Tomcat 7, J2EE, XBRL, JSF, Struts, HIBERNATE, XBRL, JAXB, OOAD, JSP, JDBC, UML, XML, XSLT, MySQL, JQuery, SOAP, WSDL, AJAX, Git, ANT, Payment gateway, Jira, confluence."
						},{
						name: "wp.esef-manager.eu",
						desc:"Mit dem neuen geforderten ESEF-Berichtsformat tritt die Jahresfinanzberichtserstattung in das digitale Zeitalter. Dadurch ändern sich die Erstellungsprozesse für Emittenten, sowie Prüfprozesse für Wirtschaftsprüfer. Um den neuen regulatorischen Anforderungen gerecht zu werden, empfiehlt sich eine technische Lösung. Im ESEF-Manager können Jahresfinanzberichte sowohl im ESEF-Berichtsformat erstellt, als auch geprüft werden. ",
						stack:"Tomcat 7, J2EE, XBRL, JSF, Struts, HIBERNATE, XBRL, JAXB, OOAD, JSP, JDBC, UML, XML, XSLT, MySQL, JQuery, SOAP, WSDL, AJAX, Git, ANT, Payment gateway, Jira, confluence."
						},{
							name:"https://www.grundsteuer-online.de/",
							desc:"Um die Grundsteuerreform durchzusetzen, werden derzeit Grundstücks- und Immobilienbesitzer aufgefordert die „Erklärung zur Feststellung der Grundsteuerwerte“ erstmalig in 2022 abzugeben. Die sog. Feststellungserklärung dient als Grundlage der Grundsteuerzahlung nach neuem Recht ab 1. Januar 2025. Mit Grundsteuer-Online wahren Sie ganz einfach die Fristen und kommen Ihrer Verpfl ichtung nach.", 
							stack:"Tomcat 7, J2EE, XBRL, JSF, Struts, HIBERNATE, XBRL, JAXB, OOAD, JSP, JDBC, UML, XML, XSLT, MySQL, JQuery, SOAP, WSDL, AJAX, Git, ANT, Payment gateway, Jira, confluence."
						},{
						name: "www.esg-service.eu/",
						desc:"Mit dem ESG-Manager erhalten Sie die Möglichkeit, Ihren Nachhaltigkeitsbericht zu importieren, eigenständig zu taggen und in das amtliche Format zur Offenlegung zu konvertieren. Die fertige Datei dient zur Vorlage bei Ihrem Wirtschaftsprüfer. ",
						stack:"Tomcat 7, J2EE, XBRL, JSF, Struts, HIBERNATE, XBRL, JAXB, OOAD, JSP, JDBC, UML, XML, XSLT, MySQL, JQuery, SOAP, WSDL, AJAX, Git, ANT, Payment gateway, Jira, confluence."
						}
					]
        },
        {
          title: "Fullstack Developer",
          company: "Triplemind GmbH",
          company_url: "https://www.triplemind.de/",
          logo_path: "triplemind_logo.png",
          duration: "Nov 2006 - April 2011",
          location: "Offenbach, Germany",
          color: "#9b1578",
          projects:[
						{
						name: "Vacation home Booking (Unterkunft)",
						desc:"Triplemind maintains more then 200 sites for booking of accommodation. Members can put in there vacation homes on the site. And the users interested in booking the accommodation for a certain period books it through our site.",
						stack:"Environment: Jboss 4.0.1, Tomcat 5.1, J2EE, Cocoon-2.2 Framework, EJB3, Java, OOAD, JSP, Squid, Applet, JDBC, Betwixt, UML, XML, XSLT, MySQL, Dojo, SOAP, AJAX, Subversion, ANT,Maven."
						}
					]
        },
        {
          title: "Java developer",
          company: "Alphanso Informex Pvt. Ltd.(India)",
          company_url: "https://www.linkedin.com/company/freecopy/about/",
          logo_path: "alphanso_informex_logo.png",
          duration: "Oct 2003 - Sept 2004",
          location: "Pune, India",
          color: "#fc1f20",
          projects:[
						{
						name: "Discovery compass",
						desc:"Discovery Compass is web-based tool, which provides online services to the lawyers, law firms & consultancies. This facilitates the lawyers by reducing documentation & managing & creating reports, making notes and also provides online search & security to the documents.",
						stack:"Java2, Servlets, JSP, JBoss 3.2.6, AWT, SWING, APPLETS, Struts Framework, UNIX, XML, XSL, ANT, Java Mail API, Java script."
						},{
						name: "SQL Query Tool",
						desc:"This tool was developed for Alphanso Informix. The company used many different databases for developing different project. This tool was developed in order to query any database either it may be DB2, oracle, MSSQL and MySql. You just need to give the IP of the computer where the database is along with the database name, username, password and the query. The result will be displayed in the same page in tabular form. ",
						stack:"Java2, J2EE, JSP, JBoss 3.2.3, Servlets, HTML, JavaScript, ANT, JDBC, XML, Oracle 8i, DB2, MSSQL, MySQL."
						}
					]
        },
      ],
    },
    {
      title: "Internship",
      index:2,
      experiences: [
        {
          title: "Java developer Intern",
          company: "Whitestone Technology",
          company_url: "http://cinq.net",
          logo_path: "cinq_logo.gif",
          duration: "Nov 2005 - Nov 2006",
          location: "Frankfurt, Germany",
          color: "#000000",
          projects:[
						{
						name: "Whitestone Service Desk (WSD)",
						desc:"WSD provides a modern solution for incident management, problem management, change management, configuration management and true Service Level management. It also provides complete data segregation and independent workflows which can easily be tailored to individual customers' needs and also supports multiple languages, including double-byte character sets. It is a 100% browser-based application, which provides a high level of usability and speed, while minimizing deployment and maintenance costs. Whitestone Service Desk comprises of tightly integrated core modules, with additional add-on functionality. This suite, based upon the ITIL framework, delivers the functionality that your business requires.",
						stack:"JavaScript, J2EE, EJB, Servlets, JSP, Java Beans, Applets, Swing, Multithreading, XML, XMLC, Xpath, XERCES, Websphere MQ 5.0, WebLogic, JBoss 3.2.3, ANT, SMTP, IBM Tivoli Oracle 9i, DB2, MSSQL, Stored Procedures, CVS, Adobe GoLive."
						}
					]
        },
      ],
    },
    {
      title: "Master's Thesis",
      index:3,
      experiences: [
        {
          title: "Java developer Intern",
          company: "Cinq Net.",
          company_url: "http://cinq.net",
          logo_path: "cinq_logo.gif",
          duration: "Nov 2005 - Nov 2006",
          location: "Frankfurt, Germany",
          color: "#000000",
          projects:[
						{
						name: "Financial Research Tool",
						desc:"Focusing on the American Stock Exchange committee this application was developed to calculate the points of the insiders who have bought the shares based on certain criteria and all this is done by the stored procedures written in pgsql. Based on insiders points and his future trading its possible to predict the future price of the shares. ",
						stack:"Jboss 4.0.1, J2EE, EJB, Java, OOAD, JSP, Applet, JFreeChart, JDBC, Java Mail API, UML, XML, PostGreSQL 8.1(Pg/Sql,Pljava), Spring Framework, JSF Framework, JSTL, Hibernate O/R Mapper, DWR, SOAP, AJAX, Subversion, ANT, Rational Rose J2EE Enterprise Edition."
						}
					]
        },
      ],
    },
    {
      title: "Personal Projects",
      index:4,
      experiences: [
        {
          title: "Fullstack Developer",
          company: "",
          company_url: "http://www.usedgaadi.in",
          logo_path: "usedgaadi_logo.png",
          duration: "",
          location: "",
          color: "#4285F4",
          projects:[
						{
						name: "Marketplace for used cars",
						desc:"Project:Portal for buying and selling used cars!",
						stack:"Tomcat 7.0, JSF 2.0, Spring 3.0, Primefaces, Hibernate, XML, Mysql, AJAX, JAXB,  Subversion and Ant."
						}
					]
        },
        {
          title: "Fullstack Developer",
          company: "",
          company_url: "http://www.MyAcers.in",
          logo_path: "myacers_logo.png",
          duration: "",
          location: "",
          color: "#4285F4",
          projects:[
						{
						name: "Marketplace for properties",
						desc:":Portal for buying and selling properties across india!",
						stack:"Tomcat 7.0, JSF 2.0, Spring 3.0, Primefaces, Hibernate, XML, Mysql, AJAX, JAXB,  Subversion and Ant."
						}
					]
        },
        
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

// Projects Page
const servicePageHeader = {
  title: "Full Stack Development",
  description: "⚡ Building responsive website front end using React-Redux \n ⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin ⚡ Creating application backend in Node, Express & Flask",
  avatar_image_path: "projects_image.svg",
};
// Projects Page
const aboutPageHeader = {
  title: "Über Mich",
  description: "Ich Biete Unternehmen ganzheitliche, agile und nutzerzentrierte Technologie-Beratung an. Unser Unternehmen hat sich auf Software-Entwicklung, UX/UI Design, Digital Transformation und Innovationsberatung spezialisiert. Wir wissen, welchem Innovationsdruck Unternehmen in allen Branchen ausgesetzt sind – und dass es oft nicht leicht fällt, den Weg zu mehr Innovation zu gehen. Damit Unternehmer:innen die richtigen Schritte gehen, beraten wir zu den Themen Software-Entwicklung, Design, agiles Arbeiten, Digitalisierung, Innovation und entwickeln Lösungen: von zukunftsweisenden digitalen Produkten.",
  avatar_image_path: "projects_image.svg",
};
const karrierPageHeader = {
  title: "Gemeinsam IT-Lösungen auf die Straße bringen",
  description: "Du kommst aus der IT-Branche und suchst nach einer beruflichen Herausforderung? Dann hast du sie hiermit gefunden: Bei InnoApps hast du die Möglichkeit, Dinge selbst in die Hand zu nehmen, neue Projekte umzusetzen und dabei deine volle Kreativität zum Einsatz zu bringen. Und das ist noch nicht alles: Wir ermöglichen dir individuelle Weiterbildung, Benefits und eine ausgewogene Work-Life-Balance.",
  avatar_image_path: "projects_image.svg",
};

const serviceSkills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Frontend-Entwicklung",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux",
        "⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin",
        "⚡ Creating application backend in Node, Express & Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "devicon:css3-wordmark",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "skill-icons:typescript",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "simple-icons:gatsby",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "ES6",
          imageSrc: "es6.jpg",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "GrapgQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#E538AC",
          },
        },
        {
          skillName: "ExpressJS",
          imageSrc: "expressjs.png",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FD6C35",
          },
        },
        {
          skillName: "GitLab",
          fontAwesomeClassname: "logos:gitlab",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "IntelliJ IDEA",
          fontAwesomeClassname: "logos:intellij-idea",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "ESLint",
          fontAwesomeClassname: "logos:eslint",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Atom",
          fontAwesomeClassname: "skill-icons:atom",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Babel",
          fontAwesomeClassname: "skill-icons:babel",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "WebStorm",
          fontAwesomeClassname: "logos:webstorm",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "SourceTree",
          fontAwesomeClassname: "logos:sourcetree",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Jira",
          fontAwesomeClassname: "logos:jira",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Confluence",
          fontAwesomeClassname: "logos:confluence",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "Backend-Entwicklung",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux",
        "⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin",
        "⚡ Creating application backend in Node, Express & Flask",
      ],
      softwareSkills: [
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "skill-icons:typescript",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Kafka",
          fontAwesomeClassname: "skill-icons:kafka",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "skill-icons:git",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "skill-icons:docker",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Gradle",
          fontAwesomeClassname: "simple-icons:gradle",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Hibernate",
          fontAwesomeClassname: "simple-icons:hibernate",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Spring",
          fontAwesomeClassname: "simple-icons:spring",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "logos:aws",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Google Cloud",
          fontAwesomeClassname: "devicon:googlecloud",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "devicon:azure",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "logos:kubernetes",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "IntelliJ IDEA",
          fontAwesomeClassname: "logos:intellij-idea",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Eclipse",
          fontAwesomeClassname: "devicon:eclipse",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "GrapgQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#E538AC",
          },
        },
        {
          skillName: "Tomcat",
          fontAwesomeClassname: "logos:tomcat",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Apache",
          fontAwesomeClassname: "logos:apache",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "logos:redis",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "RabbitMQ",
          fontAwesomeClassname: "devicon:rabbitmq",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Markdown",
          fontAwesomeClassname: "logos:markdown",
          style: {
            color: "#02569B",
          },
        },
        
        {
          skillName: "npm",
          fontAwesomeClassname: "logos:npm-icon",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Kibana",
          fontAwesomeClassname: "logos:kibana",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "ESLint",
          fontAwesomeClassname: "logos:eslint",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Atom",
          fontAwesomeClassname: "skill-icons:atom",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Logstash",
          fontAwesomeClassname: "logos:logstash",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Apache Camel",
          fontAwesomeClassname: "logos:apache-camel",
          style: {
            color: "#02569B",
          },
        },
        {
					skillName: "XBRL",
					imageSrc: "XBRL.png",
				},
      ]
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_ashutosh.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android, Cloud and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Ambavadi vas, Kanodar, T.A.-Palanpur, Dist.-Banaskantha, Gujarat - 385520",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
  servicePageHeader,
  serviceSkills,
  aboutPageHeader,
  karrierPageHeader
};